import { queryOptions } from '@tanstack/vue-query'
import merge from 'lodash/merge'
import { queryClient } from '@/plugins/tanstack'
import { getTeamsV2 } from '@/common/services/TeamsService'
import localizationItemServerData from '@/common/services/serverData/localizationItemServerData'
import { invalidateQuery, queryKeyFactory } from '@/common/services/serverData/serverDataManager'
import { SERVER_DATA_LABELS, SERVER_DATA_SCOPE, SERVER_DATA_TYPE, type GroupOptionsBase } from '@/common/types/cacheConstants'

function groupOptions(config: GroupOptionsBase = {}) {
  const defaultConfig = {
    queryKey: queryKeyFactory({
      scope: SERVER_DATA_SCOPE.TEAMS,
      type: SERVER_DATA_TYPE.LIST,
    }),
    staleTime: Infinity,
    queryFn: getTeamsV2,
  }
  return queryOptions(merge(defaultConfig, config))
}

async function fetch(options: GroupOptionsBase = {}) {
  const { staleTime } = options
  const [result] = await Promise.all([
    queryClient.fetchQuery(groupOptions(options)),
    localizationItemServerData.fetch({
      prefixes: SERVER_DATA_LABELS.TEAMS,
      staleTime,
    }),
  ])
  return result
}

function invalidate() {
  invalidateQuery([
    queryKeyFactory({
      scope: SERVER_DATA_SCOPE.TEAMS,
      type: SERVER_DATA_TYPE.LIST,
    }),
  ])
}

export default {
  fetch,
  groupOptions,
  invalidate,
}
